import React from 'react';
import { Box } from '@mui/material';

const formatCompactMs = (value) => {
  const ms = Number(value);
  if (!Number.isFinite(ms) || ms < 0) return '';
  return ms < 1000 ? `${Math.round(ms)} ms` : `${(ms / 1000).toFixed(2)} s`;
};

const STATES = {
  healthy: { label: 'FAST', color: '#45d69c' },
  kairos: { label: 'KAIROS DELAY', color: '#ff9866' },
  request_path: { label: 'REQUEST PATH', color: '#5aa9ff' },
  workstation: { label: 'WORKSTATION STALLS', color: '#b597ff' },
  mixed: { label: 'MIXED', color: '#ffd166' },
};

const presentationFor = (report) => {
  if (!report || report.first_image_ms == null) {
    return { label: 'MEASURING…', color: '#78909c', time: '' };
  }
  const expected = Math.max(0, Number(report.viewport_count) || 0);
  const accepted = Math.max(0, Number(report.painted_viewport_count) || 0);
  if (report.outcome !== 'complete' || expected <= 0 || accepted < expected) {
    return { label: 'PARTIAL', color: '#ffd166', time: formatCompactMs(report.first_image_ms) };
  }
  return {
    ...(STATES[report?.diagnosis?.code] || STATES.mixed),
    time: formatCompactMs(report.first_image_ms),
  };
};

const StudyPerformanceStatusPill = ({ report, onOpen }) => {
  const state = presentationFor(report);
  const expected = Math.max(0, Number(report?.viewport_count) || 0);
  const accepted = Math.max(0, Number(report?.painted_viewport_count) || 0);
  const label = `${state.label}${state.time ? ` · ${state.time}` : ''}`;
  const coverage = expected > 0 ? `${accepted} of ${expected} viewports accepted` : 'accepted pixels pending';

  return (
    <Box
      component="button"
      type="button"
      onClick={onOpen}
      aria-label={`Performance ${label}, ${coverage}. Open details`}
      data-kairos-performance-pill="RADIOLOGIST_GLANCEABLE_ACCEPTED_PIXEL_STATUS"
      sx={{
        appearance: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.65,
        minHeight: 20,
        px: 0.85,
        py: 0.2,
        color: state.color,
        bgcolor: 'rgba(5,10,12,0.96)',
        border: `1px solid ${state.color}4d`,
        borderRadius: 1,
        fontFamily: 'monospace',
        fontSize: 10,
        fontWeight: 800,
        letterSpacing: 0.15,
        lineHeight: 1.2,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        '&:hover': { bgcolor: `${state.color}12`, borderColor: `${state.color}88` },
        '&:focus-visible': { outline: `2px solid ${state.color}`, outlineOffset: 1 },
      }}
    >
      <Box component="span" aria-hidden="true" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: state.color, boxShadow: `0 0 7px ${state.color}88`, flex: '0 0 auto' }} />
      <Box component="span">{label}</Box>
    </Box>
  );
};

export default StudyPerformanceStatusPill;
